import { useTranslation } from "react-i18next";
import { CustomModal } from "@/components/CustomModal";
import DeleteIcon from "@assets/icons/delete.svg?raw&inline";
import EditIcon from "@assets/icons/edit.svg?raw&inline";
import { isDirectorContact, isShareholderContact } from "../contact-helper";
import type { ContactFormValues } from "../schema";

type Contact = ContactFormValues;

interface ContactCardProps {
  contact: Contact;
  modalTitle: string;
  onDelete: () => void;
  renderForm: (handlers: { onClose: () => void }) => React.ReactNode;
}

export function ContactCard({
  contact,
  modalTitle,
  onDelete,
  renderForm,
}: ContactCardProps) {
  const { t } = useTranslation();

  return (
    <div className="col-12 col-md-6">
      <div className="d-flex flex-column justify-content-between p-3 border rounded h-100">
        <div className="d-flex flex-column">
          <div className="d-flex gap-2 justify-content-between">
            <div className="d-flex flex-column min-w-0 flex-grow-1">
              <div className="fw-bold text-truncate">
                {contact.nombre || t("contacts.no_name")}
              </div>
              {isDirectorContact(contact) && contact.cargo && (
                <div className="text-muted text-capitalize">
                  {t(`directors.contact_form.cargo_options.${contact.cargo}`)}
                </div>
              )}
              <div className="text-muted" style={{ wordBreak: "break-word" }}>
                {contact.email} - {contact.telefono}
              </div>
            </div>
            <div className="d-flex gap-2 flex-shrink-0">
              <CustomModal
                title={modalTitle}
                size="md"
                trigger={
                  <button type="button" className="btn p-0 size-14">
                    <span
                      className="size-10"
                      dangerouslySetInnerHTML={{ __html: EditIcon }}
                    />
                    {t("contacts.edit")}
                  </button>
                }
              >
                {(handlers) => renderForm(handlers)}
              </CustomModal>
              <button
                type="button"
                className="btn p-0 size-14"
                onClick={onDelete}
              >
                <span
                  className="size-10"
                  dangerouslySetInnerHTML={{ __html: DeleteIcon }}
                />
                {t("contacts.delete")}
              </button>
            </div>
          </div>
          {contact.soy_quien_completa_registro && (
            <span className="text-muted mt-1">
              {t("contacts.completes_registration")}
            </span>
          )}
        </div>
        {isShareholderContact(contact) && (
          <div className="d-flex gap-2">
            <div className="text-success">
              {t("contacts.shareholder_participation")}:{" "}
              {contact.porcentaje_beneficio}%
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
